export enum PrechekinFormEnum {
  PersonalInformation = 'personal-information',
  CitizenshipResidency = 'citizenship-residency',
  Passport = 'passport',
  PilotLicense = 'pilot-license',
  MedicalCertificate = 'medical-certificate',
  Visa = 'visa',
  HotelInformation = 'hotel-information'
}
